export enum DirectoryEntityType {
    Other = 0,
    HealthcareProvider = 1,
    Pharmacy = 2
}
